<div class="list-navigation__container">
  <div class="list-navigation d-flex">
    @for (nav of navConfig; track nav.label; let i = $index) {
      <div class="nav-item" [routerLinkActive]="'active'" (click)="onNavSelect(nav)">
        <div [routerLink]="nav.url" class="nav-item__name" [class.test]="nav.showUnread">
          {{ nav.label | translate }}
        </div>
        @if (nav?.showUnread) {
          <span class="unread-dot"></span>
        }
        @if (nav?.unreadCount) {
          <span class="notification-bubble">{{ nav.unreadCount }}</span>
        }
      </div>
    }
  </div>
</div>
